(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/provider.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/provider.js');
"use strict";


const store = svs.gamePackage.redux.store;
const Provider = _ref => {
  let children = _ref.children;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.gamePackage.redux.Provider = Provider;

 })(window);